export const LeftJoinSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="63" height="42" viewBox="0 0 63 42" fill="none">
    <circle cx="42" cy="21" r="20.5" fill="white" stroke="#DEE2E6" />
    <circle opacity="0.6" cx="21" cy="21" r="20.5" fill="#E9ECEF" stroke="#DEE2E6" />
  </svg>
);

export const LeftJoinSvgActive = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="63" height="42" viewBox="0 0 63 42" fill="none">
    <circle cx="42" cy="21" r="20.5" fill="white" stroke="#74C0FC" />
    <circle opacity="0.6" cx="21" cy="21" r="20.5" fill="#A5D8FF" stroke="#339AF0" />
  </svg>
);

export const InnerJoinSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="63" height="42" viewBox="0 0 63 42" fill="none">
    <circle cx="42" cy="21" r="20.5" fill="white" stroke="#DEE2E6" />
    <circle cx="21" cy="21" r="20.5" fill="white" stroke="#DEE2E6" />
    <mask id="path-3-inside-1_12446_36696" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.5 39.1907C37.7769 35.5597 42 28.7731 42 21.0001C42 13.2272 37.7769 6.44057 31.5 2.80957C25.2231 6.44057 21 13.2272 21 21.0001C21 28.7731 25.2231 35.5597 31.5 39.1907Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.5 39.1907C37.7769 35.5597 42 28.7731 42 21.0001C42 13.2272 37.7769 6.44057 31.5 2.80957C25.2231 6.44057 21 13.2272 21 21.0001C21 28.7731 25.2231 35.5597 31.5 39.1907Z"
      fill="#E9ECEF"
    />
    <path
      d="M31.5 39.1907L30.9993 40.0563L31.5 40.346L32.0007 40.0563L31.5 39.1907ZM31.5 2.80957L32.0007 1.94396L31.5 1.65431L30.9993 1.94396L31.5 2.80957ZM41 21.0001C41 28.4017 36.9799 34.8655 30.9993 38.3251L32.0007 40.0563C38.5739 36.2539 43 29.1445 43 21.0001H41ZM30.9993 3.67518C36.9799 7.13478 41 13.5986 41 21.0001H43C43 12.8558 38.5739 5.74636 32.0007 1.94396L30.9993 3.67518ZM22 21.0001C22 13.5986 26.0201 7.13478 32.0007 3.67518L30.9993 1.94396C24.4261 5.74636 20 12.8558 20 21.0001H22ZM32.0007 38.3251C26.0201 34.8655 22 28.4017 22 21.0001H20C20 29.1445 24.4261 36.2539 30.9993 40.0563L32.0007 38.3251Z"
      fill="#ADB5BD"
      mask="url(#path-3-inside-1_12446_36696)"
    />
  </svg>
);

export const InnerJoinSvgActive = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="63" height="42" viewBox="0 0 63 42" fill="none">
    <circle cx="42" cy="21" r="20.5" fill="white" stroke="#74C0FC" />
    <circle cx="21" cy="21" r="20.5" fill="white" stroke="#74C0FC" />
    <mask id="path-3-inside-1_12446_36696" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.5 39.1907C37.7769 35.5597 42 28.7731 42 21.0001C42 13.2272 37.7769 6.44057 31.5 2.80957C25.2231 6.44057 21 13.2272 21 21.0001C21 28.7731 25.2231 35.5597 31.5 39.1907Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.5 39.1907C37.7769 35.5597 42 28.7731 42 21.0001C42 13.2272 37.7769 6.44057 31.5 2.80957C25.2231 6.44057 21 13.2272 21 21.0001C21 28.7731 25.2231 35.5597 31.5 39.1907Z"
      fill="#A5D8FF"
    />
    <path
      d="M31.5 39.1907L30.9993 40.0563L31.5 40.346L32.0007 40.0563L31.5 39.1907ZM31.5 2.80957L32.0007 1.94396L31.5 1.65431L30.9993 1.94396L31.5 2.80957ZM41 21.0001C41 28.4017 36.9799 34.8655 30.9993 38.3251L32.0007 40.0563C38.5739 36.2539 43 29.1445 43 21.0001H41ZM30.9993 3.67518C36.9799 7.13478 41 13.5986 41 21.0001H43C43 12.8558 38.5739 5.74636 32.0007 1.94396L30.9993 3.67518ZM22 21.0001C22 13.5986 26.0201 7.13478 32.0007 3.67518L30.9993 1.94396C24.4261 5.74636 20 12.8558 20 21.0001H22ZM32.0007 38.3251C26.0201 34.8655 22 28.4017 22 21.0001H20C20 29.1445 24.4261 36.2539 30.9993 40.0563L32.0007 38.3251Z"
      fill="#74C0FC"
      mask="url(#path-3-inside-1_12446_36696)"
    />
  </svg>
);

export const FullJoinSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="63" height="42" viewBox="0 0 63 42" fill="none">
    <circle opacity="0.6" cx="42" cy="21" r="20.5" fill="#E9ECEF" stroke="#ADB5BD" />
    <circle opacity="0.6" cx="21" cy="21" r="20.5" fill="#E9ECEF" stroke="#ADB5BD" />
    <g opacity="0.6">
      <mask id="path-3-inside-1_12446_36771" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.5 39.1907C37.7769 35.5597 42 28.7731 42 21.0001C42 13.2272 37.7769 6.44057 31.5 2.80957C25.2231 6.44057 21 13.2272 21 21.0001C21 28.7731 25.2231 35.5597 31.5 39.1907Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.5 39.1907C37.7769 35.5597 42 28.7731 42 21.0001C42 13.2272 37.7769 6.44057 31.5 2.80957C25.2231 6.44057 21 13.2272 21 21.0001C21 28.7731 25.2231 35.5597 31.5 39.1907Z"
        fill="#F1F3F5"
      />
      <path
        d="M31.5 39.1907L30.9993 40.0563L31.5 40.346L32.0007 40.0563L31.5 39.1907ZM31.5 2.80957L32.0007 1.94396L31.5 1.65431L30.9993 1.94396L31.5 2.80957ZM41 21.0001C41 28.4017 36.9799 34.8655 30.9993 38.3251L32.0007 40.0563C38.5739 36.2539 43 29.1445 43 21.0001H41ZM30.9993 3.67518C36.9799 7.13478 41 13.5986 41 21.0001H43C43 12.8558 38.5739 5.74636 32.0007 1.94396L30.9993 3.67518ZM22 21.0001C22 13.5986 26.0201 7.13478 32.0007 3.67518L30.9993 1.94396C24.4261 5.74636 20 12.8558 20 21.0001H22ZM32.0007 38.3251C26.0201 34.8655 22 28.4017 22 21.0001H20C20 29.1445 24.4261 36.2539 30.9993 40.0563L32.0007 38.3251Z"
        fill="#DEE2E6"
        mask="url(#path-3-inside-1_12446_36771)"
      />
    </g>
  </svg>
);

export const FullJoinSvgActive = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="63" height="42" viewBox="0 0 63 42" fill="none">
    <circle opacity="0.6" cx="42" cy="21" r="20.5" fill="#A5D8FF" stroke="#74C0FC" />
    <circle opacity="0.6" cx="21" cy="21" r="20.5" fill="#A5D8FF" stroke="#74C0FC" />
    <g opacity="0.6">
      <mask id="path-3-inside-1_12446_36771" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.5 39.1907C37.7769 35.5597 42 28.7731 42 21.0001C42 13.2272 37.7769 6.44057 31.5 2.80957C25.2231 6.44057 21 13.2272 21 21.0001C21 28.7731 25.2231 35.5597 31.5 39.1907Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.5 39.1907C37.7769 35.5597 42 28.7731 42 21.0001C42 13.2272 37.7769 6.44057 31.5 2.80957C25.2231 6.44057 21 13.2272 21 21.0001C21 28.7731 25.2231 35.5597 31.5 39.1907Z"
        fill="#74C0FC"
      />
      <path
        d="M31.5 39.1907L30.9993 40.0563L31.5 40.346L32.0007 40.0563L31.5 39.1907ZM31.5 2.80957L32.0007 1.94396L31.5 1.65431L30.9993 1.94396L31.5 2.80957ZM41 21.0001C41 28.4017 36.9799 34.8655 30.9993 38.3251L32.0007 40.0563C38.5739 36.2539 43 29.1445 43 21.0001H41ZM30.9993 3.67518C36.9799 7.13478 41 13.5986 41 21.0001H43C43 12.8558 38.5739 5.74636 32.0007 1.94396L30.9993 3.67518ZM22 21.0001C22 13.5986 26.0201 7.13478 32.0007 3.67518L30.9993 1.94396C24.4261 5.74636 20 12.8558 20 21.0001H22ZM32.0007 38.3251C26.0201 34.8655 22 28.4017 22 21.0001H20C20 29.1445 24.4261 36.2539 30.9993 40.0563L32.0007 38.3251Z"
        fill="#74C0FC"
        mask="url(#path-3-inside-1_12446_36771)"
      />
    </g>
  </svg>
);
